import { Dispatch } from 'redux';
import { ToastCategories, ToastsActionTypes, ToastTypes } from './toasts';


interface NetworkCallParams {
  networkCall: () => Promise<{ body?: unknown; [key: string]: unknown }>;
  dispatch: Dispatch;
  successActionType: string;
  errorTitleId?: string;
  errorMessageId: string;
  formatMessage: (params: { id: string }) => string;
  returnBody?: boolean; // Optional, defaults to true
  successCallback?: (response: unknown) => void;
}

const handleNetworkCall = async ({
  networkCall,
  dispatch,
  successActionType,
  errorTitleId,
  errorMessageId,
  formatMessage,
  returnBody = true,
  successCallback,
}: NetworkCallParams): Promise<unknown | null> => {
  try {
    const response = await networkCall();

    if (response) {
      if (returnBody) {
        dispatch({
          type: successActionType,
          payload: response.body,
        });
        if (successCallback) successCallback(response.body);
        return returnBody ? response.body : response;
      }

      dispatch({
        type: successActionType,
        payload: response,
      });
      if (successCallback) successCallback(response);
      return response;
    }

    dispatch({
      type: ToastsActionTypes.ADD_TOAST,
      payload: {
        title: formatMessage({ id: errorTitleId || 'text.networkError' }),
        type: ToastTypes.ERROR,
        category: ToastCategories.FLAG,
        message: formatMessage({ id: errorMessageId }),
      },
    });
    return null;
  } catch (error) {
    dispatch({
      type: ToastsActionTypes.ADD_TOAST,
      payload: {
        title: formatMessage({ id: errorTitleId || 'text.networkError' }),
        type: ToastTypes.ERROR,
        category: ToastCategories.FLAG,
        message: error.message || formatMessage({ id: errorMessageId }),
      },
    });
    return null;
  }
};

export default handleNetworkCall;
